import { OpsRotaApiError } from '@/services/opsRota/client';
import type { OpsSchedule } from '@/services/opsRota/types';
import type { OpsScheduleFailReason } from '@/util/vexo';

/**
 * Why a schedule write failed, as the `reason` dimension of
 * `ops_schedule_failed`:
 *   stale:    409, or 404 on an existing block (changed or deleted meanwhile)
 *   rejected: graphy refused it (an overlap, a past date: 400 / 422)
 *   error:    anything else (network, 5xx, a bug)
 */
export const failReason = (
  err: unknown,
  existing: boolean,
): { reason: OpsScheduleFailReason; status: number | null } => {
  if (!(err instanceof OpsRotaApiError))
    return { reason: 'error', status: null };
  const { status } = err;
  if (err.isConflict || (existing && status === 404)) {
    return { reason: 'stale', status };
  }
  if (status !== null && status >= 400 && status < 500) {
    return { reason: 'rejected', status };
  }
  return { reason: 'error', status };
};

/** BR-01: an end at or before the start runs into the next day. */
export const isOvernight = (s: Pick<OpsSchedule, 'start_time' | 'end_time'>) =>
  s.end_time <= s.start_time;
